import { withInstall } from '@element-plus/utils'
import Watermark from './src/watermark.vue'

export const ElWatermarkV2 = withInstall(Watermark)
export default ElWatermarkV2

export * from './src/watermark'
